import '@web3modal/polyfills';
export { EVMWagmiClient } from './client.js';
export { defaultConfig as defaultWagmiConfig } from './utils/defaultConfig.js';
export { authConnector } from './connectors/AuthConnector.js';
//# sourceMappingURL=index.js.map